/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Marquee from "react-fast-marquee";
import {
  playSong,
  setBodyEvents,
  setEvents,
  setMixEvents,
  setConfirmData,
} from "../../common/actions/common.actions";
import logo from "../../../assets/icons/logoNew.png";
import dashboardService from "../../../api/services/dashboardService";
import withAuth from "../../common/hoc/withAuth";
import SideBarToggle from "../../common/components/sidebar/SideBarToggle";
import PopupModal from "./popupModal";
import { useTranslation } from "react-i18next";
import {
  IoFootball,
  IoStatsChart,
  IoCheckmarkDoneCircle,
  IoTime,
  IoDocumentText,
  IoTrophy,
  IoShareSocial,
  IoMegaphone,
  IoReceipt,
} from "react-icons/io5";
import signalRConnection from "../../../signalR/signalRService";
import { selectLoginData } from "../login/login.actions";

function Dashboard({ setShowSideBar, setIsLoading }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [displayTextArr, setDisplayTextArr] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { userDetails } = useSelector(selectLoginData);
  const [userBalance, setUserBalance] = useState(userDetails?.balance);

  const playClick = useCallback(() => {
    dispatch(playSong());
  }, [dispatch]);

  const goTo = useCallback(
    (path) => {
      playClick();
      navigate(path);
    },
    [playClick, navigate]
  );

  const updateUserBalance = useCallback(async (userDetailTmp) => {
    if (!userDetailTmp?.userId) return;
    try {
      const userId = Number(userDetailTmp.userId);
      const res = await dashboardService
        .getBalanceForDashboard(userId)
        .then((response) => response.json());
      if (res?.userInfo?.[0]) {
        setUserBalance(res.userInfo[0].balance);
        localStorage.setItem("userDetails", JSON.stringify(res.userInfo[0]));
      }
    } catch (error) {
      console.error("Error updating user balance:", error);
    }
  }, []);

  const initData = useCallback(async () => {
    try {
      setIsLoading(true);
      dispatch(setConfirmData(null));

      const data = await dashboardService.getDisplayTextForDashboard().json();
      setDisplayTextArr(data || []);
      await updateUserBalance(userDetails || {});
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, setIsLoading, updateUserBalance, userDetails]);

  useEffect(() => {
    const onChangedBalance = async () => {
      await updateUserBalance(userDetails || {});
    };
    signalRConnection.on("changedBalance", onChangedBalance);
    return () => {
      signalRConnection.off("changedBalance", onChangedBalance);
    };
  }, [updateUserBalance, userDetails]);

  useEffect(() => {
    initData();
    dispatch(setMixEvents([]));
    dispatch(setBodyEvents([]));
    dispatch(setEvents([]));

    const storedUserDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (storedUserDetails?.balance) {
      setUserBalance(storedUserDetails.balance);
    }
  }, [dispatch, initData]);

  const cards = [
    {
      key: "maungg",
      title: t("maungg"),
      subtitle: "Football betting",
      icon: <IoFootball size={21} className="text-white" />,
      onClick: () => goTo("/maungg"),
    },
    {
      key: "body",
      title: t("body"),
      subtitle: t("totalGoals"),
      icon: <IoStatsChart size={21} className="text-white" />,
      onClick: () => goTo("/body"),
    },
    {
      key: "selected",
      title: t("selected"),
      subtitle: t("matches"),
      icon: <IoCheckmarkDoneCircle size={21} className="text-white" />,
      onClick: () => goTo("/selected-matches"),
    },
    {
      key: "oldHistories",
      title: t("oldHistories"),
      subtitle: "Betting history",
      icon: <IoTime size={21} className="text-white" />,
      onClick: () => goTo("/old-histories"),
    },
    {
      key: "rules",
      title: "Rules",
      subtitle: t("rule"),
      icon: <IoDocumentText size={21} className="text-white" />,
      onClick: () => goTo("/rules"),
    },
    {
      key: "goalResult",
      title: t("goalResult"),
      subtitle: "Match results",
      icon: <IoTrophy size={21} className="text-white" />,
      onClick: () => goTo("/goal-score"),
    },
  ];

  const tickerText = displayTextArr.map((d) => d.displayText).join("  â€¢  ");

  return (
    <div className="relative flex flex-col w-full h-[100dvh] overflow-hidden">
      <div className="absolute inset-0 bg-[linear-gradient(125deg,#A50D21_50%,#E7082A_50%)]" />
      <div className="absolute top-16 -right-20 w-64 h-12 bg-ep_White/20 rounded-md rotate-[125deg]" />
      <div className="absolute top-2 -right-4 w-48 h-12 bg-ep_White/20 rounded-md rotate-[125deg]" />
      <div className="absolute -bottom-2 right-10 w-32 h-12 bg-ep_White/20 rounded-md rotate-[125deg]" />
      {/* <div className="absolute top-20 left-10 h-24 w-14 text-white/60 bg-dot-pattern [background-size:12px_12px]" />
      <div className="absolute bottom-96 right-8 h-14 w-32 text-white/60 bg-dot-pattern [background-size:12px_12px]" /> */}

      <div className="relative z-10 flex-1 overflow-y-auto">
        <div className="w-full max-w-5xl px-4 pt-4 pb-6 mx-auto space-y-4">
          <div className="relative rounded-md border border-ep_White/25 bg-ep_White/10 backdrop-blur-sm overflow-hidden">
            <div className="px-4 py-4">
              <div className="flex items-center justify-between gap-3" >
                <div className="flex items-center gap-3">
                  <div className="mr-9">
                    <SideBarToggle setShowSideBar={setShowSideBar}/>
                  </div>
                  <div>
                    <p className="text-xs font-bold tracking-widest uppercase text-ep_White/80">Dashboard</p>
                    <p className="text-sm font-semibold text-ep_White">Welcome back</p>
                  </div>
                </div>

                <div className="text-right px-3 py-2 rounded-md border border-ep_White/20 bg-ep_White/10">
                  <p className="text-[10px] font-bold uppercase tracking-widest text-ep_White/75">Balance</p>
                  <p className="text-base font-bold text-ep_White">{Number(userBalance || 0).toLocaleString()} Ks</p>
                </div>
              </div>

              <div className="flex flex-col items-center mt-4">
                <img src={logo} alt="logo" className="h-14 mb-1.5 drop-shadow-lg" />
                <h1 className="text-2xl font-bold leading-tight text-ep_White font-myanmarKhay">EP SPORTS</h1>
                <div className="flex items-center space-x-2 mt-1.5">
                  <div className="w-8 h-px bg-ep_White/70" />
                  <p className="text-xs font-bold tracking-widest uppercase text-ep_White">Premium Elite</p>
                  <div className="w-8 h-px bg-ep_White/70" />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-2 mt-4">
                <button
                  onClick={() => goTo("/account")}
                  className="relative overflow-hidden bg-ep_Gold rounded-md border border-ep_Gold/70 px-3 py-2.5"
                >
                  <div className="relative z-10 flex items-center justify-center space-x-2">
                    <IoReceipt size={16} className="text-white" />
                    <span className="text-xs font-bold tracking-wide text-white uppercase">History</span>
                  </div>
                </button>

                <button
                  onClick={() => goTo("/share")}
                  className="relative overflow-hidden bg-ep_White/10 rounded-md border border-ep_White/30 px-3 py-1"
                >
                  <div className="relative z-10 flex items-center justify-center space-x-2">
                    <IoShareSocial size={14} className="text-ep_White" />
                    <span className="text-xs font-bold tracking-wide text-ep_White uppercase">{t("share")}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>

          <button
            onClick={() => setIsPopupOpen((prev) => !prev)}
            className="w-full text-left border border-ep_White/20 bg-ep_White/10 backdrop-blur-sm rounded-md px-4 py-3"
          >
            <div className="flex items-center gap-3">
              <div className="relative">
                <div className="flex items-center justify-center w-10 h-10 border bg-ep_Gold rounded-md border-ep_Gold/60">
                  <IoMegaphone size={18} className="text-white" />
                </div>
                <div className="absolute -top-1 -right-1 w-3 h-3 bg-ep_Gold rounded-md border-2 border-white/70 animate-pulse" />
              </div>
              <div className="flex-1 overflow-hidden">
                <p className="text-[10px] font-bold tracking-widest uppercase text-ep_White/80 mb-0.5">Breaking News</p>
                <Marquee speed={40} gradient={false}>
                  <span className="text-sm font-semibold text-ep_White">{tickerText || "No updates right now."}</span>
                </Marquee>
              </div>
            </div>
          </button>

          <div>
            <div className="flex items-center justify-between mb-3 px-1">
              <h2 className="text-sm font-bold tracking-widest uppercase text-ep_White">Game Modes</h2>
              <p className="text-xs text-ep_White/75">Choose one to continue</p>
            </div>

            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
              {cards.map((card) => (
                <button
                  key={card.key}
                  onClick={card.onClick}
                  className="group relative overflow-hidden text-left transition-all duration-300 border shadow-xl bg-ep_White/10 backdrop-blur-sm rounded-md hover:shadow-2xl hover:-translate-y-1 border-ep_White/25 hover:border-ep_White/45 p-3"
                >
                  <div className="absolute inset-0 transition-all duration-300 bg-gradient-to-br from-ep_White/5 via-transparent to-ep_Gold/10 group-hover:from-ep_White/10 group-hover:to-ep_Gold/20" />
                  <div className="relative z-10">
                    <div className="w-12 h-12 bg-ep_Gold rounded-md mb-2.5 flex items-center justify-center shadow-md">
                      {card.icon}
                    </div>
                    <h3 className="text-sm font-bold text-ep_White leading-snug">{card.title}</h3>
                    <p className="mt-0.5 text-xs font-medium text-ep_White/80">{card.subtitle}</p>
                    <div className="mt-3 h-px bg-gradient-to-r from-ep_White/40 via-ep_Gold to-transparent" />
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* <button
            onClick={() => goTo("/share")}
            className="w-full relative overflow-hidden transition-all duration-300 border cursor-pointer bg-ep_Gold rounded-md hover:brightness-105 border-ep_Gold/70"
          >
            <div className="relative flex items-center justify-center p-2 space-x-3">
              <div className="flex items-center justify-center w-10 h-10 border bg-ep_White/20 rounded-md border-ep_White/40">
                <IoShareSocial size={18} className="text-white" />
              </div>
              <div className="text-left">
                <h3 className="text-lg font-bold text-white mb-0.5">{t("share")}</h3>
              </div>
            </div>
          </button> */}
        </div>
      </div>

      <PopupModal data={displayTextArr} isPopupOpen={isPopupOpen} setIsPopupOpen={setIsPopupOpen} />
    </div>
  );
}

export default withAuth(Dashboard);